import { FAILED } from "../utils/constants/tags";
import { getAbsoluteUrl } from "./urls";
import { fetchAuthenticated } from "./utils";

export interface SyncInvoicesResponse {
  status: string;
  detail: string;
  created: number;
  skipped: number;
}

export const syncInvoices = async (): Promise<SyncInvoicesResponse> => {
  let response: Response = { ok: false } as Response;
  const fullUrl = getAbsoluteUrl("/accounting_entries/sync_invoices/");
  try {
    response = await fetchAuthenticated(fullUrl, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "POST",
      credentials: "include",
    });
  } catch (error) {
    return {
      status: FAILED,
      detail: "No se pudo sincronizar",
      skipped: 0,
      created: 0,
    };
  }

  const responseData: SyncInvoicesResponse = await response.json();
  return responseData;
};
